import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=0ebe26bf&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "./Terms.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Terms.vue?vue&type=style&index=1&id=0ebe26bf&lang=scss&scoped=true&"
import style2 from "./Terms.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebe26bf",
  null
  
)

export default component.exports